import { identify, init } from '@fullstory/browser';
import { UserRole } from '../CommonSelectors/CommonArea.types';

interface FullstoryParams {
  productName_str: string;
  role: UserRole;
  householdId: string | null;
  externalFirmId: string | null;
  externalUserId: string | null;
  externalSystemId: string | null;
  organizationName: string;
  firmId: string | null;
  email?: string;
  displayName: string;
  userId: string;
}

export function identifyFullstoryUser(UID: string, userParams: Partial<FullstoryParams>) {
  identify(UID, {
    ...userParams,
    // eslint-disable-next-line @typescript-eslint/camelcase
    productName_str: 'Orion Planning',
    role: userParams.role && UserRole[userParams.role],
    email: userParams.role === UserRole.Advisor ? userParams.email : undefined,
  });
}

export function initFullstory(email: string, userParams: Partial<FullstoryParams>) {
  init({ orgId: '174G8N' });

  identifyFullstoryUser(
    email,
    userParams.externalSystemId === '2' && userParams.externalFirmId !== null
      ? { ...userParams, firmId: userParams.externalFirmId }
      : userParams,
  );
}
